export default "__VITE_ASSET__Cm$woh9c__"